import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { RestService } from "../rest.service";
import { catchError, retry } from "rxjs/operators";
import { TimeZoneUtils } from "../utils/timezone.utils";

@Component({
  selector: "app-add-user",
  templateUrl: "./add-user.component.html",
  styleUrls: ["./add-user.component.css"],
})
export class AddUserComponent implements OnInit {
  LoginUserDetails: any;
  UserListArray: any;
  isShown = false;
  isload = false;
  iseditModelShown: boolean = false;
  oktaUserArray: any;
  user: any;
  regUserDetails: any;
  rolesList: any;
  individualRoleList: any = [];
  isRoleDataFetched: boolean = false;
  isEditDataFetched: boolean = false;
  isUserSearchNotFilled: boolean = false;
  isSelectedRoleNotFilled: boolean = false;
  isDatafound: boolean = false;
  oktaUserArrayEmpty: boolean = false;
  isLoading: boolean = false;

  groupNameswithduplicate: any = [];
  schedule: any = [];
  maintenance: any = [];
  others: any = [];

  editUserRoleObject: any;
  editUserObject: any;
  edituserSchedule: any = [];
  edituserMaintenance: any = [];
  edituserOthers: any = [];
  filterArray: any = [];
  actualArray: any = [];

  firstname: string = "";
  lastname: string = "";
  email: string = "";
  etfname: string = "";
  etlname: string = "";
  etmail: string = "";
  role: string = "";
  status: any = "";
  statusNumber: any = "";

  selectedUser: string = "";
  selectedRole: any = "";
  isUserSelectionHasError: boolean = false;
  isRoleHasError: boolean = false;
  roleSet: any = [];
  isUserExists: boolean = false;
  isUserAdded: boolean = false;
  isSuccess: boolean = false;
  isUserUpdated: boolean = false;
  userUpdatedMsg: any = "";

  isFailure: boolean = false;
  failureMessage: any = "";

  isInfoModel: boolean = false;
  infoMessage: any = "";

  isConfirmModel: boolean = false;
  confirmMessage: any = "";

  isUserSaved: boolean = false;
  userSavedMessage: any = "";

  isNameSorted: boolean = false;
  isEmailSorted: boolean = false;
  isRoleSorted: boolean = false;
  isStatusSorted: boolean = false;
  isCreatedSorted: boolean = false;

  pageSize: any = 0;
  boxSize: any = 0;
  minValue: any = 0;
  maxValue: any = 0;
  prevValue: any = 0;
  totalJobsCount: number = 0;
  paginationLength: number = 0;

  timezoneInfo: boolean = false;
  selectedTimeZone: string = "";
  localTimeZone: string = "";

  constructor(private _restService: RestService, private router: Router) {}

  ngOnInit() {
    this.selectedTimeZone = localStorage.getItem("selectedTimeZone");
    this.localTimeZone = localStorage.getItem("localTimeZone");
    this.checkTimezone();

    var superAdmin = localStorage.getItem("isSuper");
    superAdmin !== "1"
      ? (localStorage.clear(), this.router.navigate([""]))
      : "";

    this._restService.userDetails
      .pipe(
        catchError((e) => {
          console.log("err --->", e);
          alert("Something went wrong!");
          return e;
        })
      )
      .subscribe(
        (d) => (
          (this.LoginUserDetails = d),
          console.log("Data from user list", localStorage.getItem("token"))
        )
      );

    // Receiving users list
    this._restService
      .getUserLists()
      .pipe(
        catchError((e) => {
          console.log("err --->", e);
          this.isInfoModel = true;
          this.infoMessage = e.error.StatusInfo;
          return e;
        })
      )
      .subscribe(
        (userlist: any) => (
          console.log("p", userlist.users),
          (this.filterArray = []),
          (this.UserListArray = userlist.users),
          (this.actualArray = userlist.users),
          this.actualArray.forEach(m => m.CreatedAt = TimeZoneUtils.timezoneConvert(m.CreatedAt) ),
          this.actualArray.map((f: any) =>
            f.Status === 1
              ? (f.Statustxt = "Active")
              : f.Status === 0
              ? (f.Statustxt = "Inactive")
              : f.Status === 2
              ? (f.Statustxt = "Pending")
              : f.Status === 3
              ? (f.Statustxt = "Deleted")
              : ""
          ),
          this.actualArray.map(
            (f: any) => (f.date = new Date(f.CreatedAt).toString())
          ),
          (this.totalJobsCount = parseFloat(userlist.users.length) / 5),
          (this.paginationLength =
            this.totalJobsCount % 1 === 0
              ? Math.round(this.totalJobsCount)
              : Math.round(this.totalJobsCount) + 1),
          this.loopingPagination(userlist.users.length),
          this.actualArray.map((f: any, index: any) =>
            index + 1 <= 5 ? this.filterArray.push(f) : ""
          ),
          console.log("this.UserListArray", this.UserListArray)
        )
      );

    // getting register user list from auto complete search and assigning to respective input fields
    this._restService.regUserDetails.subscribe(
      (user) => (
        (this.firstname = user.firstName),
        (this.lastname = user.lastName),
        (this.email = user.email),
        (this.selectedUser = user.name),
        (this.isUserSearchNotFilled = false)
      )
    );
  }

  loopingPagination(l: any) {
    this.minValue = 1;
    this.maxValue = l > 5 ? 5 : l;
    this.pageSize = l;
    this.prevValue = 0;
    console.log("pageSize", this.pageSize);
  }

  nextpage(c: any, type: any) {
    let pageSize = this.pageSize;
    this.minValue = c + 1;
    this.maxValue = c + 5 >= pageSize ? pageSize : c + 5;
    this.prevValue = c;

    console.log(this.minValue + "---" + this.maxValue + "---" + this.pageSize);

    type === "normal"
      ? ((this.filterArray = []),
        this.actualArray.map((f: any, index: any) =>
          index + 1 >= this.minValue && index + 1 <= this.maxValue
            ? this.filterArray.push(f)
            : ""
        ))
      : "";
  }

  prevpage(p: any, type: any) {
    this.minValue = p - 5 + 1;
    this.maxValue = p;
    this.prevValue = p - 5;

    console.log(this.minValue + "---" + this.maxValue + "---" + this.prevValue);

    type === "normal"
      ? ((this.filterArray = []),
        this.actualArray.map((f: any, index: any) =>
          index + 1 >= this.minValue && index + 1 <= this.maxValue
            ? this.filterArray.push(f)
            : ""
        ))
      : "";
  }

  checkTimezone() {
    var dt = new Date();
    var offset = dt.getTimezoneOffset();
    var timezone: any = parseInt(localStorage.getItem("timezone"));

    if (Math.abs(offset) !== Math.abs(timezone)) {
      this.timezoneInfo = true;
    } else {
      this.timezoneInfo = false;
    }
  }

  sortingName() {
    let sortedList: any = [];
    this.filterArray = [];

    if (this.isNameSorted === false) {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return a.FirstName.localeCompare(b.FirstName);
      });
      this.isNameSorted = true;
      //this.filterArray = sortedList;
      (this.totalJobsCount = parseFloat(sortedList.length) / 5),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 5 ? this.filterArray.push(f) : ""
        );
    } else {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return b.FirstName.localeCompare(a.FirstName);
      });
      this.isNameSorted = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 5),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 5 ? this.filterArray.push(f) : ""
        );
    }
  }

  sortingEmail() {
    let sortedList: any = [];
    this.filterArray = [];

    if (this.isEmailSorted === false) {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return a.Email.localeCompare(b.Email);
      });
      this.isEmailSorted = true;
      //this.filterArray = sortedList;
      (this.totalJobsCount = parseFloat(sortedList.length) / 5),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 5 ? this.filterArray.push(f) : ""
        );
    } else {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return b.Email.localeCompare(a.Email);
      });
      this.isEmailSorted = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 5),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 5 ? this.filterArray.push(f) : ""
        );
    }
  }

  sortingRole() {
    let sortedList: any = [];
    this.filterArray = [];

    if (this.isRoleSorted === false) {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return a.RoleName.localeCompare(b.RoleName);
      });
      this.isRoleSorted = true;
      //this.filterArray = sortedList;
      (this.totalJobsCount = parseFloat(sortedList.length) / 5),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 5 ? this.filterArray.push(f) : ""
        );
    } else {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return b.RoleName.localeCompare(a.RoleName);
      });
      this.isRoleSorted = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 5),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 5 ? this.filterArray.push(f) : ""
        );
    }
  }

  sortingCreated() {
    let sortedList: any = [];
    this.filterArray = [];

    if (this.isCreatedSorted === false) {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return a.CreatedAt.localeCompare(b.CreatedAt);
      });
      this.isCreatedSorted = true;
      //this.filterArray = sortedList;
      (this.totalJobsCount = parseFloat(sortedList.length) / 5),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 5 ? this.filterArray.push(f) : ""
        );
    } else {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return b.CreatedAt.localeCompare(a.CreatedAt);
      });
      this.isCreatedSorted = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 5),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 5 ? this.filterArray.push(f) : ""
        );
    }
  }

  sortingStatus() {
    let sortedList: any = [];
    this.filterArray = [];

    if (this.isStatusSorted === false) {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return a.Statustxt.localeCompare(b.Statustxt);
      });
      this.isStatusSorted = true;
      //this.filterArray = sortedList;
      (this.totalJobsCount = parseFloat(sortedList.length) / 5),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 5 ? this.filterArray.push(f) : ""
        );
    } else {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return b.Statustxt.localeCompare(a.Statustxt);
      });
      this.isStatusSorted = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 5),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 5 ? this.filterArray.push(f) : ""
        );
    }
  }

  searchKeyword(e: any) {
    if (e.target.value === "") {
      (this.filterArray = []),
        (this.totalJobsCount = parseFloat(this.actualArray.length) / 5),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(this.actualArray.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 5 ? this.filterArray.push(f) : ""
        );
    } else {
      let v = e.target.value.toLowerCase();
      let temp: any = [];
      this.filterArray = [];

      this.actualArray.map((f: any) =>
        f.Status === 1
          ? (f.Statustxt = "Active")
          : f.Status === 0
          ? (f.Statustxt = "Inactive")
          : f.Status === 2
          ? (f.Statustxt = "Pending")
          : f.Status === 3
          ? (f.Statustxt = "Deleted")
          : ""
      ),
        this.actualArray.map(
          (f: any) => (f.date = new Date(f.CreatedAt).toString())
        ),
        this.actualArray.map((f: any) =>
          f.FirstName.toLowerCase().includes(v) ||
          f.Email.toLowerCase().includes(v) ||
          f.date.toLowerCase().includes(v) ||
          f.RoleName.toLowerCase().includes(v) ||
          f.Statustxt.toLowerCase().includes(v)
            ? temp.push(f)
            : ""
        );

      (this.totalJobsCount =
        this.actualArray.length > 5
          ? parseFloat(this.actualArray.length) / 5
          : 1),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(temp.length),
        temp.map((f: any, index: any) =>
          index + 1 <= 5 ? this.filterArray.push(f) : ""
        );
    }
  }

  // Receiving okta user list for auto complete
  addingNewUser() {
    this.role = "";
    this.selectedRole = "";
    this.firstname = "";
    this.lastname = "";
    this.email = "";
    this.schedule = [];
    this.maintenance = [];
    this.others = [];
    this.isUserSearchNotFilled = false;
    this.isSelectedRoleNotFilled = false;
    this.isUserSaved = false;
    this.isLoading = true;

    this.isShown = true;
    this._restService
      .getOktaUser()
      .pipe(
        catchError((e) => {
          console.log("err --->", e);
          this.isLoading = false;
          this.isInfoModel = true;
          this.infoMessage = e.error.StatusInfo;
          return e;
        })
      )
      .subscribe(
        (oktaUsers: any) => (
          ((this.oktaUserArray = oktaUsers),
          oktaUsers.length > 0
            ? (this.oktaUserArrayEmpty = false)
            : (this.oktaUserArrayEmpty = true)),
          localStorage.setItem("integrationType", oktaUsers.IntegrationType),
          (this.isLoading = false)
        )
      );
  }

  close() {
    this.isShown = false;
    this._restService
      .getUserLists()
      .pipe(
        catchError((e) => {
          console.log("err --->", e);
          this.isInfoModel = true;
          this.infoMessage = e.error.StatusInfo;
          return e;
        })
      )
      .subscribe(
        (userlist: any) => (
          console.log("p", userlist.users),
          (this.filterArray = []),
          (this.UserListArray = userlist.users),
          (this.actualArray = userlist.users),
          this.actualArray.forEach(m => m.CreatedAt = TimeZoneUtils.timezoneConvert(m.CreatedAt) ),
          this.actualArray.map((f: any) =>
            f.Status === 1
              ? (f.Statustxt = "Active")
              : f.Status === 0
              ? (f.Statustxt = "Inactive")
              : f.Status === 2
              ? (f.Statustxt = "Pending")
              : f.Status === 3
              ? (f.Statustxt = "Deleted")
              : ""
          ),
          this.actualArray.map(
            (f: any) => (f.date = new Date(f.CreatedAt).toString())
          ),
          (this.totalJobsCount = parseFloat(userlist.users.length) / 5),
          (this.paginationLength =
            this.totalJobsCount % 1 === 0
              ? Math.round(this.totalJobsCount)
              : Math.round(this.totalJobsCount) + 1),
          this.loopingPagination(userlist.users.length),
          this.actualArray.map((f: any, index: any) =>
            index + 1 <= 5 ? this.filterArray.push(f) : ""
          ),
          console.log("this.UserListArray", this.UserListArray)
        )
      );
  }

  onChangingRole(roles: any, val: string) {
    this.roleSet = [];
    this.selectedRole =
      roles.target.options[roles.target.options.selectedIndex].text;
    this.isRoleDataFetched = true;
    this.individualRoleList = this.oktaUserArray.permissions[val];

    this.oktaUserArray.roles.filter((f: any) =>
      f.RoleId === parseInt(val)
        ? (this.roleSet.push(f), console.log("f ------>>", this.roleSet))
        : ""
    );

    this.individualRoleList.map(
      (m: any) => (
        m.View === 1 ? (m.isViewEditable = true) : (m.isViewEditable = false),
        m.Add_Edit === 1 ? (m.isAddEditable = true) : (m.isAddEditable = false),
        m.Delete === 1
          ? (m.isDeleteEditable = true)
          : (m.isDeleteEditable = false)
      )
    );

    console.log("individualRoleList", this.individualRoleList);

    this.schedule = [];
    this.maintenance = [];
    this.others = [];

    this.individualRoleList.filter((f: any) =>
      f.GroupName === "schedule"
        ? this.schedule.push(f)
        : f.GroupName === "maintenance"
        ? this.maintenance.push(f)
        : f.GroupName === "others"
        ? this.others.push(f)
        : ""
    );

    this.isSelectedRoleNotFilled = false;

    console.log("Schedule", this.schedule);
    console.log("Maintenance", this.maintenance);
    console.log("Others", this.others);
  }

  onViewEvent(e: any, id: any) {
    let checkedValue: any;

    e.target.checked === true ? (checkedValue = 1) : (checkedValue = 0);

    this.individualRoleList.filter((f: any) =>
      f.id === id ? (f.View = checkedValue) : ""
    );

    console.log("Updated", this.individualRoleList);
  }

  onEditEvent(e: any, id: any) {
    let checkedValue: any;

    e.target.checked === true ? (checkedValue = 1) : (checkedValue = 0);
    this.individualRoleList.filter((f: any) =>
      f.id === id ? (f.Add_Edit = checkedValue) : ""
    );
    console.log("Updated", this.individualRoleList);
  }

  onDeleteEvent(e: any, id: any) {
    let checkedValue: any;
    e.target.checked === true ? (checkedValue = 1) : (checkedValue = 0);
    this.individualRoleList.filter((f: any) =>
      f.id === id ? (f.Delete = checkedValue) : ""
    );
    console.log("Updated", this.individualRoleList);
  }

  addNewUserEvent() {
    console.log(this.firstname + "---" + this.selectedRole);

    this.firstname === ""
      ? (this.isUserSearchNotFilled = true)
      : (this.isUserSearchNotFilled = false);
    this.selectedRole === ""
      ? (this.isSelectedRoleNotFilled = true)
      : (this.isSelectedRoleNotFilled = false);

    if (this.firstname !== "" && this.selectedRole !== "") {
      this.isLoading = true;
      this._restService
        .addingNewUserInList(
          this.firstname,
          this.lastname,
          this.email,
          this.selectedRole,
          this.roleSet,
          this.individualRoleList
        )
        .pipe(
          catchError((e) => {
            console.log("err --->", e);
            this.isLoading = false;
            this.isInfoModel = true;
            this.infoMessage = e.error.StatusInfo;
            return e;
          })
        )
        .subscribe(
          (response: any) => (
            console.log("addNewUserEvent ---->>>>", response),
            (this.isUserSaved = true),
            (this.isLoading = false),
            (this.userSavedMessage = response.StatusInfo(
              (this.isUserAdded = true)
            )),
            this._restService
              .getUserLists()
              .pipe(
                catchError((e) => {
                  console.log("err --->", e);
                  this.isInfoModel = true;
                  this.infoMessage = e.error.StatusInfo;
                  return e;
                })
              )
              .subscribe(
                (userlist: any) => (
                  console.log("p", userlist.users),
                  (this.filterArray = []),
                  (this.UserListArray = userlist.users),
                  (this.actualArray = userlist.users),
                  this.actualArray.forEach(m => m.CreatedAt = TimeZoneUtils.timezoneConvert(m.CreatedAt) ),
                  this.actualArray.map((f: any) =>
                    f.Status === 1
                      ? (f.Statustxt = "Active")
                      : f.Status === 0
                      ? (f.Statustxt = "Inactive")
                      : f.Status === 2
                      ? (f.Statustxt = "Pending")
                      : f.Status === 3
                      ? (f.Statustxt = "Deleted")
                      : ""
                  ),
                  this.actualArray.map(
                    (f: any) => (f.date = new Date(f.CreatedAt).toString())
                  ),
                  (this.totalJobsCount = parseFloat(userlist.users.length) / 5),
                  (this.paginationLength =
                    this.totalJobsCount % 1 === 0
                      ? Math.round(this.totalJobsCount)
                      : Math.round(this.totalJobsCount) + 1),
                  this.loopingPagination(userlist.users.length),
                  this.actualArray.map((f: any, index: any) =>
                    index + 1 <= 5 ? this.filterArray.push(f) : ""
                  ),
                  console.log("this.UserListArray", this.UserListArray)
                )
              )
          )
        );
    }
  }

  onEditingUserDetails(userid: any) {
    (this.isUserUpdated = false), localStorage.setItem("editUserId", userid);
    this.iseditModelShown = true;

    this.edituserSchedule = [];
    this.edituserMaintenance = [];
    this.edituserOthers = [];

    this._restService
      .editUserDetails(userid)
      .pipe(
        catchError((e) => {
          console.log("err --->", e.error.StatusInfo);
          this.isFailure = true;
          this.failureMessage = e.error.StatusInfo;
          return e;
        })
      )
      .subscribe(
        (res: any) => (
          console.log("Responssasdsdsdsd", res),
          (this.editUserRoleObject = res.roles),
          this.editUserRoleObject.map(
            (m: any) => (
              m.View === 1
                ? (m.isViewEditable = true)
                : (m.isViewEditable = false),
              m.Add_Edit === 1
                ? (m.isAddEditable = true)
                : (m.isAddEditable = false),
              m.Delete === 1
                ? (m.isDeleteEditable = true)
                : (m.isDeleteEditable = false)
            )
          ),
          this.editUserRoleObject.filter((f: any) =>
            f.GroupName === "schedule"
              ? this.edituserSchedule.push(f)
              : f.GroupName === "maintenance"
              ? this.edituserMaintenance.push(f)
              : f.GroupName === "others"
              ? this.edituserOthers.push(f)
              : ""
          ),
          ((this.editUserObject = res.user),
          (this.etfname = res.user.FirstName),
          (this.etlname = res.user.LastName),
          (this.etmail = res.user.Email),
          (this.status = res.user.Status)),
          console.log("this.edituserSchedule", this.editUserRoleObject)
        )
      );
  }

  closeEditModel() {
    this.iseditModelShown = false;
  }

  onUpdateViewEvent(e: any, id: any) {
    let checkedValue: any = e.target.checked === true ? 1 : 0;
    this.editUserRoleObject.filter((f: any) =>
      f.id === id ? (f.View = checkedValue) : ""
    );
    console.log("Updated", this.editUserRoleObject);
  }

  onUpdateEditEvent(e: any, id: any) {
    let checkedValue: any = e.target.checked === true ? 1 : 0;
    this.editUserRoleObject.filter((f: any) =>
      f.id === id ? (f.Add_Edit = checkedValue) : ""
    );
    console.log("Updated", this.editUserRoleObject);
  }

  onUpdateDeleteEvent(e: any, id: any) {
    let checkedValue: any = e.target.checked === true ? 1 : 0;
    this.editUserRoleObject.filter((f: any) =>
      f.id === id ? (f.Delete = checkedValue) : ""
    );
    console.log("Updated", this.editUserRoleObject);
  }

  updateUserDetails() {
    let eId = localStorage.getItem("editUserId");
    let fName = this.editUserObject.FirstName;
    let lName = this.editUserObject.LastName;
    let emailAdd = this.editUserObject.Email;
    let createdAt = this.editUserObject.CreatedAt;
    let roleId = this.editUserObject.RoleId;
    let editUserRole = this.editUserRoleObject;

    this.isLoading = true;

    this._restService
      .updatingUserDetails(
        eId,
        fName,
        lName,
        emailAdd,
        createdAt,
        roleId,
        editUserRole
      )
      .pipe(
        catchError((e) => {
          this.isLoading = false;
          (this.isUserUpdated = true),
            (this.userUpdatedMsg = e.error.StatusInfo);
          console.log("Onload Error --->", e.error);
          return e;
        })
      )
      .subscribe(
        (response: any) => (
          console.log(response),
          (this.isLoading = false),
          (this.isUserUpdated = true),
          (this.userUpdatedMsg = response.StatusInfo)
        )
      );
  }

  onUpdatingUserStatus(eid: any, statusId: any) {
    console.log("statusId", statusId);
    localStorage.setItem("editUserId", eid);
    if (statusId === 3) {
      this.statusNumber = statusId;
      this.isConfirmModel = true;
      this.confirmMessage = "Are you sure you want to delete this user ?";
    } else {
      this.iseditModelShown = false;
      this._restService
        .updateUserStatus(statusId)
        .pipe(
          catchError((e) => {
            console.log("err --->", e);
            this.isInfoModel = true;
            this.infoMessage = e.error.StatusInfo;
            return e;
          })
        )
        .subscribe((response: any) =>
          this._restService
            .getUserLists()
            .pipe(
              catchError((e) => {
                console.log("err --->", e);
                this.isInfoModel = true;
                this.infoMessage = e.error.StatusInfo;
                return e;
              })
            )
            .subscribe(
              (userlist: any) => (
                console.log("p", userlist.users),
                (this.filterArray = []),
                (this.UserListArray = userlist.users),
                (this.actualArray = userlist.users),
                this.actualArray.forEach(m => m.CreatedAt = TimeZoneUtils.timezoneConvert(m.CreatedAt) ),
                this.actualArray.map((f: any) =>
                  f.Status === 1
                    ? (f.Statustxt = "Active")
                    : f.Status === 0
                    ? (f.Statustxt = "Inactive")
                    : f.Status === 2
                    ? (f.Statustxt = "Pending")
                    : f.Status === 3
                    ? (f.Statustxt = "Deleted")
                    : ""
                ),
                this.actualArray.map(
                  (f: any) => (f.date = new Date(f.CreatedAt).toString())
                ),
                (this.totalJobsCount = parseFloat(userlist.users.length) / 5),
                (this.paginationLength =
                  this.totalJobsCount % 1 === 0
                    ? Math.round(this.totalJobsCount)
                    : Math.round(this.totalJobsCount) + 1),
                this.loopingPagination(userlist.users.length),
                this.actualArray.map((f: any, index: any) =>
                  index + 1 <= 5 ? this.filterArray.push(f) : ""
                ),
                console.log("this.UserListArray", this.UserListArray)
              )
            )
        );
    }
  }

  onUpdatingUserStatusEnable(eid: any, statusId: any) {
    this.isLoading = true;
    this.iseditModelShown = false;
    localStorage.setItem("editUserId", eid);
    this._restService
      .updateUserStatus(statusId)
      .pipe(
        catchError((e) => {
          console.log("err --->", e);
          this.isLoading = false;
          this.isInfoModel = true;
          this.infoMessage = e.error.StatusInfo;
          return e;
        })
      )
      .subscribe(
        (response: any) => (
          (this.isLoading = false),
          this._restService
            .getUserLists()
            .pipe(
              catchError((e) => {
                console.log("err --->", e);
                this.isInfoModel = true;
                this.infoMessage = e.error.StatusInfo;
                return e;
              })
            )
            .subscribe(
              (userlist: any) => (
                console.log("p", userlist.users),
                (this.filterArray = []),
                (this.UserListArray = userlist.users),
                (this.actualArray = userlist.users),
                this.actualArray.forEach(m => m.CreatedAt = TimeZoneUtils.timezoneConvert(m.CreatedAt) ),
                this.actualArray.map((f: any) =>
                  f.Status === 1
                    ? (f.Statustxt = "Active")
                    : f.Status === 0
                    ? (f.Statustxt = "Inactive")
                    : f.Status === 2
                    ? (f.Statustxt = "Pending")
                    : f.Status === 3
                    ? (f.Statustxt = "Deleted")
                    : ""
                ),
                this.actualArray.map(
                  (f: any) => (f.date = new Date(f.CreatedAt).toString())
                ),
                (this.totalJobsCount = parseFloat(userlist.users.length) / 5),
                (this.paginationLength =
                  this.totalJobsCount % 1 === 0
                    ? Math.round(this.totalJobsCount)
                    : Math.round(this.totalJobsCount) + 1),
                this.loopingPagination(userlist.users.length),
                this.actualArray.map((f: any, index: any) =>
                  index + 1 <= 5 ? this.filterArray.push(f) : ""
                ),
                console.log("this.UserListArray", this.UserListArray)
              )
            )
        )
      );
  }

  onUpdatingUserStatusDisable(eid: any, statusId: any) {
    this.isLoading = true;
    this.iseditModelShown = false;
    localStorage.setItem("editUserId", eid);
    this._restService
      .updateUserStatus(statusId)
      .pipe(
        catchError((e) => {
          console.log("err --->", e);
          this.isLoading = false;
          this.isInfoModel = true;
          this.infoMessage = e.error.StatusInfo;
          return e;
        })
      )
      .subscribe(
        (response: any) => (
          (this.isLoading = false),
          this._restService
            .getUserLists()
            .pipe(
              catchError((e) => {
                console.log("err --->", e);
                this.isInfoModel = true;
                this.infoMessage = e.error.StatusInfo;
                return e;
              })
            )
            .subscribe(
              (userlist: any) => (
                console.log("p", userlist.users),
                (this.filterArray = []),
                (this.UserListArray = userlist.users),
                (this.actualArray = userlist.users),
                this.actualArray.forEach(m => m.CreatedAt = TimeZoneUtils.timezoneConvert(m.CreatedAt) ),
                this.actualArray.map((f: any) =>
                  f.Status === 1
                    ? (f.Statustxt = "Active")
                    : f.Status === 0
                    ? (f.Statustxt = "Inactive")
                    : f.Status === 2
                    ? (f.Statustxt = "Pending")
                    : f.Status === 3
                    ? (f.Statustxt = "Deleted")
                    : ""
                ),
                this.actualArray.map(
                  (f: any) => (f.date = new Date(f.CreatedAt).toString())
                ),
                (this.totalJobsCount = parseFloat(userlist.users.length) / 5),
                (this.paginationLength =
                  this.totalJobsCount % 1 === 0
                    ? Math.round(this.totalJobsCount)
                    : Math.round(this.totalJobsCount) + 1),
                this.loopingPagination(userlist.users.length),
                this.actualArray.map((f: any, index: any) =>
                  index + 1 <= 5 ? this.filterArray.push(f) : ""
                ),
                console.log("this.UserListArray", this.UserListArray)
              )
            )
        )
      );
  }

  cancelConfirmEvent() {
    this.isConfirmModel = false;
    this.confirmMessage = "";
  }

  confirmEvent() {
    this.isConfirmModel = false;
    this.confirmMessage = "";

    this._restService
      .updateUserStatus(this.statusNumber)
      .pipe(
        catchError((e) => {
          console.log("err --->", e);
          this.isInfoModel = true;
          this.infoMessage = e.error.StatusInfo;
          return e;
        })
      )
      .subscribe((response: any) =>
        this._restService
          .getUserLists()
          .pipe(
            catchError((e) => {
              console.log("err --->", e);
              this.isInfoModel = true;
              this.infoMessage = e.error.StatusInfo;
              return e;
            })
          )
          .subscribe(
            (userlist: any) => (
              console.log("p", userlist.users),
              (this.filterArray = []),
              (this.UserListArray = userlist.users),
              (this.actualArray = userlist.users),
              this.actualArray.forEach(m => m.CreatedAt = TimeZoneUtils.timezoneConvert(m.CreatedAt) ),
              this.actualArray.map((f: any) =>
                f.Status === 1
                  ? (f.Statustxt = "Active")
                  : f.Status === 0
                  ? (f.Statustxt = "Inactive")
                  : f.Status === 2
                  ? (f.Statustxt = "Pending")
                  : f.Status === 3
                  ? (f.Statustxt = "Deleted")
                  : ""
              ),
              this.actualArray.map(
                (f: any) => (f.date = new Date(f.CreatedAt).toString())
              ),
              (this.totalJobsCount = parseFloat(userlist.users.length) / 5),
              (this.paginationLength =
                this.totalJobsCount % 1 === 0
                  ? Math.round(this.totalJobsCount)
                  : Math.round(this.totalJobsCount) + 1),
              this.loopingPagination(userlist.users.length),
              this.actualArray.map((f: any, index: any) =>
                index + 1 <= 5 ? this.filterArray.push(f) : ""
              ),
              console.log("this.UserListArray", this.UserListArray)
            )
          )
      );
  }

  confirmSuccess() {
    this.isShown = false;
    this.isSuccess = false;
  }

  confirmInfo() {
    this.isInfoModel = false;
    this.infoMessage === "Session Expired"
      ? (localStorage.clear(),
        (this.infoMessage = ""),
        this.router.navigate([""]))
      : (this.infoMessage = "");
  }

  confirmFailureMessage() {
    this.isFailure = false;
    this.failureMessage === "Session Expired"
      ? (localStorage.clear(),
        (this.failureMessage = ""),
        this.router.navigate([""]))
      : (this.failureMessage = "");
  }
}
